import React, { useRef, useState, useEffect } from 'react';
import Appearance from 'styles/Appearance.js';
import { VelocityComponent } from 'velocity-react';

const MultiToggle = ({ color, labelStyle, onChange, options = [], selectedIndex, style }) => {

    const ref = useRef(null);
    const [activeIndex, setActiveIndex] = useState(selectedIndex ?? 0);
    const [left, setLeft] = useState(0);

    const onOptionClick = (index, evt) => {

        evt.stopPropagation();
        
        // Calculate the left position for the slider
        const optionWidth = ref.current.clientWidth / options.length;
        setLeft(`${(index / options.length) * 100}%`);
        setActiveIndex(index);
        
        // Call onChange callback with the selected option and index
        if(typeof(onChange) === 'function') {
            onChange(options[index], index);
        }
    }

    useEffect(() => {
        if(selectedIndex !== undefined && selectedIndex !== null) {
            setActiveIndex(selectedIndex);
        }
    }, [selectedIndex]);

    useEffect(() => {
        setLeft(`${(activeIndex / options.length) * 100}%`);
    }, [options.length, activeIndex]);

    return (
        <div style={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            position: 'relative',
            width: '100%',
            ...style
        }}>
            <div
            ref={ref}
            style={{
                border: `2px solid ${Appearance.colors.softBorder()}`,
                borderRadius: 20,
                boxShadow: Appearance.boxShadow(),
                display: 'flex',
                height: 40,
                flexDirection: 'row',
                margin: 'auto',
                overflow: 'hidden',
                position: 'relative',
                width: '100%'
            }}>
                <VelocityComponent
                easing={[250, 20]}
                duration={500}
                animation={{
                    left: left,
                    width: '25%'
                }}>
                    <div
                    style={{
                        alignItems: 'center',
                        backgroundColor: color || Appearance.colors.primary(),
                        borderRadius: 2,
                        display: 'flex',
                        height: '100%',
                        justifyContent: 'center',
                        paddingLeft: 24,
                        paddingRight: 24,
                        position: 'absolute',
                        pointerEvents: 'none'
                    }}>
                        <span style={{
                            fontFamily: 'Zen Dots',
                            fontSize: 12,
                            fontWeight: 500,
                            ...labelStyle,
                            color: 'white',
                            whiteSpace: 'nowrap'
                        }}>{typeof(options[activeIndex]) === 'string' ? options[activeIndex].toUpperCase() : options[activeIndex]?.label?.toUpperCase()}</span>
                    </div>
                </VelocityComponent>
                {options.map((option, index) => {

                    const label = typeof(option) === 'string' ? option : option.label;
                    const isActive = index === activeIndex;
                    
                    return (
                        <div
                        key={index}
                        className={'cursor-pointer'}
                        onClick={onOptionClick.bind(this, index)}
                        style={{
                            alignItems: 'center',
                            borderLeft: index > 0 ? `1px solid ${Appearance.colors.softBorder()}` : 'none',
                            borderRight: index < options.length - 1 ? `1px solid ${Appearance.colors.softBorder()}` : 'none',
                            display: 'flex',
                            height: '100%',
                            justifyContent: 'center',
                            paddingLeft: 24,
                            paddingRight: 24,
                            width: `${100 / options.length}%`
                        }}>
                            <span style={{
                                fontFamily: 'Zen Dots',
                                fontSize: 12,
                                fontWeight: 500,
                                ...labelStyle,
                                color: isActive ? 'white' : Appearance.colors.text(),
                                whiteSpace: 'nowrap'
                            }}>{label.toUpperCase()}</span>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default MultiToggle;
